import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { isString } from '../util/validator.util';

@Injectable()
export class BasicDialogService {
    constructor(
        protected translateService: TranslateService
    ) { 

    }

    askPermission(){
        return Swal.fire({
          title: "Operación",
          text: "Está seguro de que desea continuar con la operación?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1'
          }
        });
    }

    confirmCancel(){
        return Swal.fire({
          title: "Cancelar",
          text: "Está seguro de que desea descartar los cambios?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Descartar",
          cancelButtonText: "Quedarse",
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-danger ml-1'
          }
        });
    }

    success(msg = null){
        if(!isString(msg)) msg = "La operación fue realizada con éxito"
        return Swal.fire({
            title: "Operación exitosa",
            text: msg,
            icon: 'success',
            confirmButtonText: "Excelente!",
            customClass: {
              confirmButton: 'btn btn-success'
            }
        });
    }

    cancel(msg = null){
        if(!isString(msg)) msg = "El registro está a salvo"
        return Swal.fire({
            title: "Cancelado",
            text: msg,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            }
        });
    }
    
    error(msg = null){
        let errMsg = msg;
        if(!isString(errMsg)) errMsg = "Error desconocido";
        
        return Swal.fire({
            title: "Error",
            text: errMsg,
            icon: 'error',
            confirmButtonText: "Ok",
        })
    }
}